export const normalizeNumber = (
  value: string | number | null | undefined,
): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const normalizedValue = Number(value);
  return Number.isFinite(normalizedValue) ? normalizedValue : null;
};
